// @flow
export default (
    hostname: ?string,
    formattedSearchUrl: string,
    basePath: ?string
): string => {
    if (hostname) {
        const sanitizedHostname = hostname.replace(/(^\w+:|^)\/\/|\//g, '');

        // Add basePath to absolute url only
        return `https://${sanitizedHostname}${
            basePath ? basePath : ''
        }${formattedSearchUrl}`;
    }

    return formattedSearchUrl;
};
